import { addDays } from "date-fns";

/**
 * @param startDate Date
 * @param endDate Date
 * @return [Date]
 * This function creates an array of days that will be used as the label of the chart.
 */

export const getWeeklyDates = (startDate: Date, endDate: Date): Date[] => {
  const dates: Date[] = [];
  let dateToCompare = startDate;

  while (dateToCompare <= endDate) {
    dates.push(dateToCompare);
    dateToCompare = addDays(dateToCompare, 1);
  }

  return dates;
};
